const question6 = {
    'question': 'Jaki czas jest przeznaczony na jedno spotkanie terapii EMDR?',
    'answer': 'Standardowa sesja terapii EMDR trwa około 60 minut. Podczas sesji terapeuta uczy pacjenta technik relaksacyjnych, takich jak oddychanie głębokie lub wizualizacja. Następnie terapeuta pomaga pacjentowi skupić się na traumatycznym wspomnieniu. Terapeuta stosuje stymulację bilateralną, taką jak ruchy gałek ocznych, dźwięki lub dotyk, aby pomóc pacjentowi przetworzyć traumatyczne wspomnienie.',
}

export default question6;